import { normalizeSearchOptions } from 'utils/common.util';
import request, { liveDataApiUrl } from 'services/request';
import {
  MarketWatchInitialDataUrl,
  WatchlistsUrl,
  WatchlistUrl,
} from 'routes/watchlist.routes';
import { updateWatchList } from 'utils/marketWatch.util';

export const getMarketWatchInitialDataAction = async (
  set,
  notShowLoading?,
): Promise<void> => {
  !notShowLoading &&
    set({
      marketWatchInitialDataLoading: true,
      marketWatchInitialDataError: false,
    });
  const response = await request.get(
    liveDataApiUrl + MarketWatchInitialDataUrl(),
  );
  response.ok
    ? set({
        socketConnectionReopen: false,
        marketWatchInitialData: response.data.initial_data,
        marketWatchInitialDataLoading: false,
        marketWatchSearchOptions: normalizeSearchOptions(
          Object.values(response.data.initial_data || {}),
        ),
      })
    : set({
        marketWatchInitialDataLoading: false,
        marketWatchInitialDataError: true,
      });
};

export const setPreferencesAction = async (set, body): Promise<void> => {
  set({
    marketWatchPreferences: body,
  });
};

export const getUserBasketListAction = async (
  set,
  id?: number,
): Promise<void> => {
  set({
    userBasketLoading: true,
    userBasketError: false,
  });
  const response = await request.get(liveDataApiUrl + WatchlistsUrl());

  response.ok
    ? set({
        userBasketList: response.data,
        userBasketLoading: false,
        currentWatchlistId: id || response.data[0].id,
      })
    : set({ userBasketLoading: false, userBasketError: true });
};

export const postNewWatchListAction = async (set, body): Promise<void> => {
  set({ addNewWatchListLoading: true });
  const response = await request.post(liveDataApiUrl + WatchlistsUrl(), {
    ...body,
    securities_symbol_12chars: [],
  });
  const responseData = response?.data;
  response.ok
    ? set((state) => ({
        addNewWatchListLoading: false,
        currentWatchlistId: responseData.id,
        userBasketList: [responseData, ...state.userBasketList],
      }))
    : set({ addNewWatchListLoading: false });
};

export const deleteWatchListAction = async (set, id): Promise<void> => {
  set({ deleteWatchListLoading: true });
  const response = await request.delete(liveDataApiUrl + WatchlistUrl(id));
  response.ok
    ? set((state) => ({
        userBasketList: state.userBasketList.filter(
          (watchlist) => watchlist.id !== id,
        ),
        deleteWatchListLoading: false,
      }))
    : set({ deleteWatchListLoading: false });
};

export const patchWatchListAction = async (set, id, name): Promise<void> => {
  set({ editWatchListNameLoading: true });
  const response = await request.patch(liveDataApiUrl + WatchlistUrl(id), {
    name,
  });

  response.ok
    ? set((state) => ({
        userBasketList: [
          ...state.userBasketList.filter((watchlist) => watchlist.id !== id),
          response.data,
        ],
        editWatchListNameLoading: false,
      }))
    : set({ editWatchListNameLoading: false });
};

export const postWatchListAction = async (
  set,
  id: number,
  securities_symbol_12chars: string[],
): Promise<boolean> => {
  set({ updateWatchListLoading: true, updateWatchListError: false });
  const response = await request.patch(liveDataApiUrl + WatchlistUrl(id), {
    securities_symbol_12chars,
  });

  if (response.ok) {
    set((state) => ({
      userBasketList: updateWatchList(state.userBasketList, response.data),
      updateWatchListLoading: false,
    }));
  } else set({ updateWatchListLoading: false, updateWatchListError: true });
  return response.ok;
};

export const getClientWatchlistAction = async (
  set,
  id,
  notShowLoading?,
): Promise<void> => {
  !notShowLoading &&
    set({ clientWatchlistLoading: true, clientWatchlistError: false });
  const response = await request.get(liveDataApiUrl + WatchlistUrl(id));

  response.ok
    ? set({
        clientWatchlistData: response.data.initial_data,
        clientWatchlistLoading: false,
        socketConnectionReopen: false,
      })
    : set({ clientWatchlistLoading: false, clientWatchlistError: true });
};
